import Home from './Routes/home.svelte';
import Pdf from './Routes/pdf.svelte';

export default {
    '/': Home,
    '/resume': Pdf,
    '/*': Home,
}